import { getSPDataWithParams, postSPDataWithoutParams } from './services'

const CARE_ORCHESTRATION_BASE = '/api/secure/cc/support/care-orchestration'

function phoneDigits(value) {
  return `${value || ''}`.replace(/\D/g, '')
}

function phoneMatches(candidate, target) {
  const candidateDigits = phoneDigits(candidate)
  const targetDigits = phoneDigits(target)
  if (!candidateDigits || !targetDigits) return false
  if (candidateDigits === targetDigits) return true
  if (candidateDigits.length >= 10 && targetDigits.length >= 10) {
    return candidateDigits.slice(-10) === targetDigits.slice(-10)
  }
  if (candidateDigits.length >= 8 && targetDigits.length >= 8) {
    return candidateDigits.endsWith(targetDigits) || targetDigits.endsWith(candidateDigits)
  }
  return false
}

function patientMatchesPhone(patient, phone) {
  const possiblePhones = [
    patient?.mobile,
    patient?.phone,
    patient?.primaryPatientProfile?.mobile,
    ...(Array.isArray(patient?.altMobiles) ? patient.altMobiles : []),
  ]
  return possiblePhones.some((value) => phoneMatches(value, phone))
}

export async function getCareOrchestrationCases(filters = {}) {
  const response = await getSPDataWithParams(`${CARE_ORCHESTRATION_BASE}/cases`, filters)
  if (response?.data?.code !== 2000) {
    const message =
      response?.data?.message ||
      response?.response?.data?.message ||
      'Unable to load care orchestration cases.'
    throw new Error(message)
  }
  return response?.data?.data?.items || []
}

export async function searchCareOrchestrationPatientMatchesByPhone(phone) {
  const digits = phoneDigits(phone)
  if (!digits) return []
  const response = await getSPDataWithParams('/api/secure/cc/support/patient/search', {
    search: phone,
    page: 1,
    pageSize: 20,
    includeEventTypes: 'true',
    includeEngagementDetails: 'true',
  })
  const responseData = Array.isArray(response?.data)
    ? response.data
    : response?.data?.data || response?.data?.content || []
  if (!Array.isArray(responseData)) return []
  return responseData.filter((patient) => patientMatchesPhone(patient, phone))
}

// POST /assign — assigns a coordinator to a case. If assignedCoordinatorId is
// empty the backend defaults to the currently-signed-in support user.
export async function assignCareOrchestrationCase(payload) {
  const response = await postSPDataWithoutParams(`${CARE_ORCHESTRATION_BASE}/assign`, payload)
  if (response?.data?.code !== 2000) {
    const message =
      response?.data?.message ||
      response?.response?.data?.message ||
      'Unable to assign care orchestration case.'
    throw new Error(message)
  }
  return response?.data?.data?.result || null
}
